import { render, staticRenderFns } from "./design.vue?vue&type=template&id=9ed2279a&scoped=true"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"
import style0 from "./design.vue?vue&type=style&index=0&id=9ed2279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed2279a",
  null
  
)

export default component.exports